export const DRAWING_TOOL = {
  PEN: "Pen",
  HIGHLIGHTER: "Highlighter",
  ERASER: "Eraser",
  IMAGE: "Image",
  TEXT_BOX: "TextBox",
};

export const CANVAS_ACTION = {
  SELECT: "select",
  MOVE: "move",
  UNDO: "undo",
  REDO: "redo",
  DELETE: "removeSelected",
  FORWARD: "forward",
  BACKWARD: "backward",
  CLEAR: "clear",
  ZOOM_IN: "zoomIn",
  ZOOM_OUT: "zoomOut",
  ZOOM_DEFAULT: "zoomDefault",
  ZOOM_FIT: "zoomFit",
  ZOOM_SLIDE: "zoomSlide",
};

export const CANVAS_ERROR = {
  BACKGROUND_LOAD_FAILED: "background.load.failed",
};

export const CANVAS_SIZE = {
  BOUNDARY_WIDTH: 5000,
  BOUNDARY_HEIGHT: 10000,
  ZOOM_MAX: 200, // canvas value: 2
  ZOOM_MIN: 20, // canvas value: 0.2
  ZOOM_IN: 10,
  ZOOM_OUT: -10,
  ZOOM_PERCENTAGE: 100,
  ZOOM_DEFAULT: 1,
};

export const CANVAS_TASK = {
  DEFAULT: "",
  CHECK_DIRTY: "checkDirty",
  NEXT: "next",
  RELOAD: "reload",
};

export const CANVAS_CURRENT_ACTION = {
  DEFAULT: "",
  NEXT: "next",
  EXIT: "exit",
};

export const BRUSH_OPACITY = {
  PEN: 1,
  HIGHLIGHTER: 0.3,
};
